import { OneAlert } from '@factorialco/f0-react/dist/experimental'
import Link from '@factorialco/f0-react/icons/app/Link'

import i18n from 'modules/core/lib/i18n'

import { getJobCatalogRoleAndLevel } from './jobCatalog'

export const JobCatalogLinkedInfoAlert = ({
  jobCatalogSerializedTree,
  jobCatalogLevelUuid,
  jobCatalogRoleUuid,
}: {
  jobCatalogSerializedTree: string
  jobCatalogLevelUuid: string
  jobCatalogRoleUuid: string
}) => {
  const { roleName, levelName } = getJobCatalogRoleAndLevel(
    jobCatalogSerializedTree,
    jobCatalogLevelUuid ?? '',
    jobCatalogRoleUuid ?? ''
  )

  return (
    <OneAlert
      title={i18n.t('ats.job_posting_settings.alerts.linked_information.title')}
      description={i18n.t('ats.job_posting_settings.alerts.linked_information.description', {
        role: roleName,
        level: levelName,
      })}
      icon={Link}
      variant="info"
    />
  )
}
